import React from 'react';
import {
  Dialog, DialogTitle, DialogContent, DialogActions,
  Box, Typography, Button, IconButton, Divider, CircularProgress,
} from '@mui/material';
import { Close, WarningAmber } from '@mui/icons-material';

// Gates closing a cash session (and offered standalone from the held-orders
// drawer) behind clearing any bill left on hold on THIS terminal — a store
// can have several terminals, each with its own held bills, so this only
// ever touches the current one (see Order#discard_held on the backend).
const DiscardHeldBillsDialog = ({ open, heldCount, onDiscardAll, onCancel, loading }) => (
  <Dialog
    open={open}
    onClose={loading ? undefined : onCancel}
    maxWidth="xs"
    fullWidth
    PaperProps={{ sx: { borderRadius: '12px', m: { xs: 2, sm: 3 } } }}
  >
    <DialogTitle sx={{ px: 2.5, py: 2, display: 'flex', alignItems: 'center', justifyContent: 'space-between', gap: 1 }}>
      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, minWidth: 0 }}>
        <Box sx={{ width: 32, height: 32, borderRadius: '8px', bgcolor: '#FFFBEB', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
          <WarningAmber sx={{ fontSize: 18, color: '#92400E' }} />
        </Box>
        <Typography fontWeight={800} fontSize="0.95rem" color="#1E293B" noWrap>Bills On Hold</Typography>
      </Box>
      <IconButton size="small" onClick={onCancel} disabled={loading} sx={{ color: '#94A3B8', mr: -0.5, flexShrink: 0 }}>
        <Close sx={{ fontSize: 18 }} />
      </IconButton>
    </DialogTitle>

    <Divider />

    <DialogContent sx={{ px: 2.5, py: 2 }}>
      <Typography sx={{ fontSize: '0.8rem', color: '#475569', lineHeight: 1.6 }}>
        This terminal has <strong>{heldCount}</strong> bill{heldCount === 1 ? '' : 's'} on hold.
        They must be discarded before the cash session can be closed.
      </Typography>
    </DialogContent>

    <Divider />

    <DialogActions sx={{ px: 2.5, py: 2 }}>
      <Button onClick={onCancel} disabled={loading} sx={{ textTransform: 'none', fontWeight: 600, color: '#64748B' }}>
        Cancel
      </Button>
      <Button
        onClick={onDiscardAll}
        disabled={loading}
        variant="contained"
        sx={{ bgcolor: '#EF4444', '&:hover': { bgcolor: '#DC2626' }, borderRadius: '8px', boxShadow: 'none', textTransform: 'none', fontWeight: 700, px: 2.5 }}
      >
        {loading ? (
          <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
            <CircularProgress size={14} sx={{ color: '#fff' }} />
            <span>Discarding...</span>
          </Box>
        ) : (
          'Discard All'
        )}
      </Button>
    </DialogActions>
  </Dialog>
);

export default DiscardHeldBillsDialog;
